import axios from 'axios';
import apiService from './apiService';

export default {
    /**
   * OIDC Login - send ID token to backend for validation
   */
    async oidcLogin(idToken) {
    // Get CSRF cookie first (not prefixed with /api)
        await axios.get(`${process.env.VUE_APP_API_URL.replace('/api', '')}/sanctum/csrf-cookie`, {
            withCredentials: true
        });

        const response = await apiService.post('/oidc_login', { id_token: idToken });
        return response.data;
    },

    /**
   * Send magic link to user's email
   */
    async sendMagicLink(email) {
    // Get CSRF cookie first (not prefixed with /api)
        await axios.get(`${process.env.VUE_APP_API_URL.replace('/api', '')}/sanctum/csrf-cookie`, {
            withCredentials: true
        });
        const returnUrl = `${window.location.origin}/login/magic/%7Btoken%7D`;
        const response = await apiService.post('/auth/magic-link', {
            email,
            return_url: returnUrl
        });
        return response.data;
    },

    /**
   * Verify magic link token and exchange for session
   */
    async verifyMagicToken(token) {
    // Get CSRF cookie first (not prefixed with /api)
        await axios.get(`${process.env.VUE_APP_API_URL.replace('/api', '')}/sanctum/csrf-cookie`, {
            withCredentials: true
        });
        const response = await apiService.post('/exchange-token-for-cookie', null, {
            headers: { Authorization: `Bearer ${atob(token)}` }
        });
        return response.data;
    },

    /**
   * Get current authenticated user
   */
    async getUser() {
        const response = await apiService.get('/auth/user');
        return response.data;
    },

    /**
   * Logout user
   */
    async logout() {
        // Get CSRF cookie first
        await axios.get(`${process.env.VUE_APP_API_URL.replace('/api', '')}/sanctum/csrf-cookie`, {
            withCredentials: true
        });
        const response = await apiService.post('/auth/logout');
        return response.data;
    }
};
